import React from "react";
import { useState } from "react";
import { Table, TableHead, TableBody, TableRow, TableCell, TableContainer, Avatar, Box, Typography } from "@mui/material";
// import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
// import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
// import { ReactComponent as Edit } from "../../../../../assets/images/edit.svg";
import styles from "./style";
// import Button from "@mui/material/Button";
// import {ReactComponent as Download} from "../../../../../assets/invoice/material-symbols_download.svg";
// import { useNavigate } from "react-router-dom";
import CustomPagination from "../../../../../components/CustomPagination";
// import profile from "../../../../../assets/ViewLeave-images/Payroll.svg"
import { useAlert } from "../../../../../context/AlertContext";
import dayjs from "dayjs";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import {ReactComponent as Edit}from "../../../../../assets/AccountingModule/uil_edit.svg";
import {ReactComponent as RemoveRedEyeOutlinedIcon} from "../../../../../assets/AccountingModule/view.svg";
import { useNavigate } from "react-router-dom";
import { getDateFormat } from "../../../../../utils/dateFormatStore";


const PurchaseList = ({ count, page, setPage,data}) => {
  const {showAlert} = useAlert();
  const navigate = useNavigate();
  const handleAlert = () =>{
    showAlert("Development In Progress","success");
  }

  // if (!data || data.length === 0) {
  //   return <div>No data available</div>;
  // }
  // const navigate = useNavigate()
  const [rowsPerPage, setRowsPerPage] = useState(8);

  // const handleNavigate = (item) => {
  //   navigate("dashboard/editInvoice",{state:{item}})
  // }
  // const handleNavigateSlip =(id) => {
  //   navigate("/dashboard/payslipGeneration",{state:{id:id}})
  // }
  //   const startIndex = page * rowsPerPage;
  //   const endIndex = startIndex + rowsPerPage;

  // const [anchorEl, setAnchorEl] = useState(null);

  // const handleClick = (event) => {
  //   setAnchorEl(event.currentTarget);
  // };

  // const handleClose = () => {
  //   setAnchorEl(null);
  // };

  // const open = Boolean(anchorEl);

  return (
    <>


      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={styles.TableHead}>Supplier</TableCell>
              <TableCell sx={styles.TableHead}>Invoice Number</TableCell>
              <TableCell sx={styles.TableHead}>Created date</TableCell>
              <TableCell sx={styles.TableHead}>Due Date</TableCell>
              <TableCell sx={styles.TableHead}>Amount</TableCell>
              <TableCell sx={styles.TableHead}>Action</TableCell>

            </TableRow>
          </TableHead>
          <TableBody>
            {data?.length === 0 ? (
              <TableRow>
                <TableCell colSpan={8} align="center">
                  <Typography variant="h6">No data</Typography>
                </TableCell>
              </TableRow>
            ) : (


              data?.map((item, index) => (

                <TableRow key={index}> 

                  <TableCell sx={styles.tableAvtardata}>
                    <Avatar src={item?.pic} sx={styles.profile} /><Box >
                      <Typography sx={styles.name}>{item?.supplierName}</Typography>
                      <Typography sx={styles.mail}>{item?.name}</Typography>
                    </Box>       </TableCell>
                  <TableCell sx={styles.tabledata}>{item?.billNumber}</TableCell>

                  <TableCell sx={styles.tabledata}>{dayjs(item?.billDate).format(getDateFormat())}</TableCell>
                  <TableCell sx={styles.tabledata}>{dayjs(item?.dueDate).format(getDateFormat())}</TableCell>
                  <TableCell sx={styles.tabledata}>{item?.grandTotal}</TableCell>

                  {/* <TableCell sx={{ borderBottom: 0 }}><Box sx={{
                    border: `1px solid ${item.status === "Paid" ? "#28AA4A" :
                      item.salaryStatus === "Rejected" ? "#FF0000" :
                        item.salaryStatus === "Pending" ? "#F4B63F" :
                          item.salaryStatus === "Approved" ?  "#28AA4A" :
                            "black"
                    }`,
                    borderRadius: "30px", display: "flex", justifyContent: "center", alignItems: "center", py: "3px", px: "14px", width: "fit-content", fontSize: "12px", 
                    color: `${item.salaryStatus === "Paid" ? "#28AA4A" :
                      item.salaryStatus === "Rejected" ? "red" :
                        item.salaryStatus === "Pending" ? "#F4B63F" :
                          item.salaryStatus === "Approved" ?  "#28AA4A"  :
                            "black"
                    }`

                  }}>Approved</Box></TableCell> */}
                  <TableCell sx={styles.tableActiondata}>
                                       
                    <Box onClick={() => navigate("/dashboard/editPurchase",{state:{item}})}><Edit /></Box>
                    <Box onClick={() => handleAlert()}sx={{mx: 2.5 }}><RemoveRedEyeOutlinedIcon /></Box>
                    <Box onClick={() => { handleAlert()}}><DeleteOutlineIcon sx={{ color: "#ff0000" }}  /></Box>
                  </TableCell>
                </TableRow>


              )))}

          </TableBody>

        </Table>

        <CustomPagination pageCount={count}totalItems={count} page={page} setPage={setPage} rowsPerPage={rowsPerPage} setRowsPerPage={setRowsPerPage} />

      </TableContainer>



      {/* <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
      >
        <Box sx={{ p: 2, pr: 6,}} >
          <Box>
            <Box onClick={handleClose}>
              <Box sx={styles.iconGrid}>
                <Box><DeleteOutlineIcon sx={styles.icon} /></Box>
                <Box sx={styles.iconText}>Delete</Box>
              </Box>
            </Box>
            <Box onClick={handleClose}>
              <Box sx={styles.iconGrid}>

                <Box><RemoveRedEyeOutlinedIcon sx={styles.icon} /></Box>
                <Box sx={styles.iconText}>View</Box>
              </Box>
            </Box>
            <Box onClick={handleClose}>
              <Box sx={styles.iconGrid}>

                <Box sx={styles.iconSvg}><Edit onClick={handleNavigate}/></Box>
                <Box sx={styles.iconText}>Edit</Box>
              </Box>
            </Box>
            <Box onClick={handleClose}>
              <Box sx={styles.iconGrid}>

                <Box sx={styles.iconSvg}><Download  /></Box>
                <Box sx={styles.iconText}>Download</Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Popover> */}

    </>
  );
};
export default PurchaseList;
